import { useGetListingDetailsV2Query } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingDetailsRpc.hooks';
import { useGetListingDetailsV2Query as useGetListingDetailsV2QueryApp } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingDetailsRpc-app.hooks';
import { convertFieldValueAvroToJson } from 'rpc-client-utils';
import { AppContextType } from '../types';

interface UseUnifiedDetailsProps {
  appContext: AppContextType;
  slug?: string;
  language?: string;
  skip?: boolean;
  clientTimeout?: number;
}

// All consumers should use the centralized useUnifiedDetails hook
// which will stay up to date with the various version bumps
// until things stabilize for release
export function useUnifiedDetailsV2({
  appContext,
  slug,
  language,
  skip,
  clientTimeout,
}: UseUnifiedDetailsProps) {
  const variables = slug
    ? language
      ? { slug, language }
      : { slug }
    : undefined;

  const context =
    clientTimeout !== undefined ? { timeout: clientTimeout } : undefined;

  const {
    data: unifiedDetailsDataInApp,
    loading: unifiedDetailsLoadingInApp,
    error: unifiedDetailsErrorInApp,
  } = useGetListingDetailsV2QueryApp({
    variables,
    skip: skip || !slug || appContext !== 'app',
    context,
  });

  const {
    data: unifiedDetailsDataPublic,
    loading: unifiedDetailsLoadingPublic,
    error: unifiedDetailsErrorPublic,
  } = useGetListingDetailsV2Query({
    variables,
    skip: skip || !slug || appContext !== 'public',
    context,
  });

  const unifiedDetailsData =
    appContext === 'app' ? unifiedDetailsDataInApp : unifiedDetailsDataPublic;

  // @ts-ignore untyped BE response
  const parsedUnifiedDetailsData: Record<string, any> =
    unifiedDetailsData?.listing
      ? convertFieldValueAvroToJson(unifiedDetailsData.listing)
      : {};

  return {
    unifiedDetailsData: parsedUnifiedDetailsData,
    unifiedDetailsLoading:
      appContext === 'app'
        ? unifiedDetailsLoadingInApp
        : unifiedDetailsLoadingPublic,
    unifiedDetailsError:
      appContext === 'app'
        ? unifiedDetailsErrorInApp
        : unifiedDetailsErrorPublic,
  };
}
